const scheduleData = [
    {
      id: 1,
      parent1: {
        name: "Parent 5",
        email: "user1@gmail.com",
        color: "#9b59b6",
        days: ["Monday", "Tuesday"],
        pickup: {
          days: ["Monday", "Tuesday"],
          time: "12:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
        dropoff: {
          days: ["Monday", "Tuesday"],
          time: "12:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
      },
      parent2: {
        name: "Parent 2",
        email: "user2@gmail.com",
        color: "#3498db",
        days: ["Sunday", "Thursday"],
        pickup: {
          days: ["Sunday", "Thursday"],
          time: "12:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
        dropoff: {
          days: ["Sunday", "Thursday"],
          time: "14:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
      },
      children: [
        {
          id: 1,
          name: "Child 1",
          chooseDays: "Parent 1 on weekdays, Parent 2 on weekends",
          times: "Parent 1 from June 1st to June 15th, then Parent 2 from June 16th to June 30th",
        },
        {
          id: 2,
          name: "Child 2",
          chooseDays: "",
          times: "",
        },
      ],
      isSameScheduleForAll: 1,
      scheduleType: {
        id: 3,
        label:
          "<strong>Parent 1:</strong> Monday, Tuesday <br> <strong>Parent 2:</strong> Sunday, Thursday",
      },
    },
    {
      id: 2,
      parent1: {
        name: "Parent 5",
        email: "user1@gmail.com",
        color: "#9b59b6",
        pickup: {
          days: ["Monday", "Tuesday"],
          time: "12:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
        dropoff: {
          days: ["Monday", "Tuesday"],
          time: "12:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
      },
      parent2: {
        name: "Parent 3",
        email: "user3@gmail.com",
        color: "#2ecc71",
        pickup: {
          days: ["Sunday", "Thursday"],
          time: "12:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
        dropoff: {
          days: ["Sunday", "Thursday"],
          time: "14:00",
          customHour: 0,
          customMinute: 0,
          showDays: true,
          showCustom: false,
          showTime: true,
        },
      },
      children: [
        {
          id: 3,
          name: "Child 1",
          chooseDays: "",
          times: "",
        },
      ],
    },
  ];

const scheduleData2 = {
    "code": 200,
    "message": "Showing Co-parenting Step2 data",
    "data": [
        [
            {
                "coparent_combination_id": "1",
                "parent1": {
                    "nickname": "Manasi Dhuri",
                    "email": null,
                    "color_id": "45"
                },
                "parent2": {
                    "nickname": "Manasi2 coparent",
                    "email": "manasidhuri21@gmail.com",
                    "color_id": "46"
                },
                "apply_same_settings_for_children": "0",
                "children": [
                    {
                        "child_id": "1",
                        "child_name": "Ganu",
                        "schedule_type_id": "42",
                        "applySameSettings": "0",
                        "parent1": {
                            "apply_same_time_all_days": "1",
                            "selected_days": [
                                "Monday",
                                "Tuesday"
                            ],
                            "responsibilities": "pick_up",
                            "pickup_time": "08:00:00"
                        },
                        "parent2": {
                            "apply_same_time_all_days": "0",
                            "selected_days": [
                                "Wednesday",
                                "Thursday"
                            ],
                            "responsibilities": "drop_off",
                            "days": [
                                {
                                    "day": "Wednesday",
                                    "responsibilities": "drop_off",
                                    "dropoff_time": "15:30:00"
                                },
                                {
                                    "day": "Thursday",
                                    "responsibilities": "pick_up",
                                    "pickup_time": "10:30:00"
                                }
                            ]
                        }
                    },
                    {
                        "child_id": "2",
                        "child_name": "Banu",
                        "schedule_type_id": "40",
                        "applySameSettings": "0",
                        "rotation_starting_parent": "parent2",
                        "week_schedules": [
                            {
                                "week_number1": {
                                    "assigned_to": "parent1",
                                    "responsibilities": "pick_up",
                                    "pickup_time": "08:00:00"
                                },
                                "week_number2": {
                                    "assigned_to": "parent2",
                                    "responsibilities": "drop_off",
                                    "dropoff_time": "17:00:00"
                                }
                            }
                        ]
                    },
                    {
                        "child_id": "3",
                        "child_name": "Manasi Jr 3",
                        "schedule_type_id": "41",
                        "applySameSettings": "0",
                        "rotation_starting_parent": "parent2",
                        "week_schedules": [
                            {
                                "week_number1": [
                                    {
                                        "selected_days": [
                                            "Monday",
                                            "Tuesday"
                                        ],
                                        "assigned_to": "parent1",
                                        "responsibilities": "pick_up",
                                        "pickup_time": "08:00:00"
                                    },
                                    {
                                        "selected_days": [
                                            "Wednesday",
                                            "Thursday"
                                        ],
                                        "assigned_to": "parent1",
                                        "responsibilities": "drop_off",
                                        "dropoff_time": "16:00:00"
                                    },
                                    {
                                        "selected_days": [
                                            "Friday",
                                            "Saturday",
                                            "Sunday"
                                        ],
                                        "assigned_to": "parent1",
                                        "responsibilities": "pick_up",
                                        "pickup_time": "09:00:00"
                                    }
                                ],
                                "week_number2": [
                                    {
                                        "selected_days": [
                                            "Monday",
                                            "Tuesday"
                                        ],
                                        "assigned_to": "parent2",
                                        "responsibilities": "pick_up",
                                        "pickup_time": "08:30:00"
                                    },
                                    {
                                        "selected_days": [
                                            "Wednesday",
                                            "Thursday"
                                        ],
                                        "assigned_to": "parent2",
                                        "responsibilities": "drop_off",
                                        "dropoff_time": "16:30:00"
                                    },
                                    {
                                        "selected_days": [
                                            "Friday",
                                            "Saturday",
                                            "Sunday"
                                        ],
                                        "assigned_to": "parent2",
                                        "responsibilities": "drop_off",
                                        "dropoff_time": "18:30:00"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        [
            {
                "coparent_combination_id": "2",
                "parent1": {
                    "nickname": "Manasi Dhuri Jr",
                    "email": null,
                    "color_id": "45"
                },
                "parent2": {
                    "nickname": "Manasi3 coparent",
                    "email": "dhurimanasi88@gmail.com",
                    "color_id": "48"
                },
                "apply_same_settings_for_children": "0",
                "children": [
                    {
                        "child_id": "4",
                        "child_name": "Dhuri Jr 1",
                        "schedule_type_id": "42",
                        "applySameSettings": "0",
                        "parent1": {
                            "apply_same_time_all_days": "1",
                            "selected_days": [
                                "Friday",
                                "Saturday",
                                "Sunday"
                            ],
                            "responsibilities": "pick_up",
                            "pickup_time": "12:00:00"
                        },
                        "parent2": {
                            "apply_same_time_all_days": "1",
                            "selected_days": [
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday"
                            ],
                            "responsibilities": "pick_up",
                            "pickup_time": "12:00:00"
                        }
                    },
                    {
                        "child_id": "5",
                        "child_name": "Dhuri Jr 2",
                        "schedule_type_id": "40",
                        "applySameSettings": "0",
                        "rotation_starting_parent": "parent2",
                        "week_schedules": [
                            {
                                "week_number1": {
                                    "assigned_to": "parent1",
                                    "responsibilities": "pick_up",
                                    "pickup_time": "09:00:00"
                                },
                                "week_number2": {
                                    "assigned_to": "parent2",
                                    "responsibilities": "drop_off",
                                    "dropoff_time": "17:00:00"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    ]
}
  
  export {scheduleData} ;
  